export enum Endpoints {
  Login = "/login",
  Register = "/register",
  CustomAttrsUrl = "/update-profile/custom-attributes/{UUID}",
  InvoicePath = "/orders/{UUID}",
  MarketCustomAttrsUrl = "/custom-attributes",
  StoreAddressesUrl = "/update-profile/addresses/{UUID}",
  UpdateAddressUrl = "/update-profile/addresses/{UUID}/{ADDRESS_ID}",
  UpdateDefaultBillingAddress = "/update-profile/addresses/{UUID}/{ADDRESS_ID}/set-default-billing",
  UpdateDefaultShippingAddress = "/update-profile/addresses/{UUID}/{ADDRESS_ID}/set-default-shipping",
  Validate = "/validate-session",
  ForgotPassword = "/forgot-password",
  ResetPassword = "/reset-consumer-password",
  // Profile endpoints
  ProfilePath = "/profile/{UUID}",
  Logout = "/logout",
  ChangePassword = "/consumers/{UUID}/change-password",
  UpdateEmail = "/request-update-email/{UUID}",
  VerifyEmailUpdate = "/verify-email-update",
  UpdatePhone = "/update-profile/phone/{UUID}",
  UpdateAv = "/profile/{UUID}/verify-age",
  VerifyPhone = "/get-verified-phone/{PHONE}",
  VerifyEmail = "/verify/{EMAIL}",
  UpdateProfile = "/update-profile/personal-details/{UUID}",
  GeneratePromoCode = "/consumers/{UUID}/generate-promo-code",
  CancelAccount = "/cancel-account/{UUID}",
  PasswordRequirements = "/password-requirements",
  Privacy = "/dsar-request",
  Wallet = "/profile/{UUID}/wallet",
}

export enum EvoEndpoints {
  Login = "/users/authentication/sessions",
  Register = "/users/register",
  CustomAttrsUrl = "/users/{UUID}/custom-attributes",
  InvoicePath = "/users/{UUID}/orders",
  MarketCustomAttrsUrl = "/users/configuration",
  StoreAddressesUrl = "/users/{UUID}/addresses",
  UpdateAddressUrl = "/users/{UUID}/addresses/{ADDRESS_ID}",
  UpdateDefaultBillingAddress = "/users/{UUID}/addresses/billing/{ADDRESS_ID}",
  UpdateDefaultShippingAddress = "/users/{UUID}/addresses/shipping/{ADDRESS_ID}",
  Validate = "/users/authentication/sessions/validate",
  ForgotPassword = "/users/authentication/password/forget",
  ResetPassword = "/users/authentication/password/change/{USER_TOKEN}",
  // Profile endpoints
  ProfilePath = "/users/{UUID}/profile",
  Logout = Login,
  ChangePassword = "/users/authentication/password/change",
  UpdateEmail = "/users/{UUID}/profile/email/request-update",
  VerifyEmailUpdate = "/users/profile/email",
  UpdatePhone = "/users/{UUID}/profile/phone",
  UpdateAv = "/users/{UUID}/av",
  VerifyPhone = "/users/verify/{PHONE}",
  VerifyEmail = "/users/verify/{EMAIL}",
  UpdateProfile = ProfilePath,
  GeneratePromoCode = "/users/{UUID}/coupons",
  CancelAccount = "/users/{UUID}/cancel",
  PasswordRequirements = MarketCustomAttrsUrl,
  Privacy = "/users/privacy",
  Consents = "/users/{UUID}/consents",
  Wallet = "/users/{UUID}/profile/wallet",
}

export enum EndpointPlaceholders {
  UUID = "{UUID}",
  ADDRESS_ID = "{ADDRESS_ID}",
  PHONE = "{PHONE}",
  EMAIL = "{EMAIL}",
  USER_TOKEN = "{USER_TOKEN}",
}
